import React, { createContext, useContext, useState, ReactNode } from "react";

type Organization = {
  id: string;
  name: string;
  desc: string;
};

type OrganizationContextType = {
  selectedOrganization: Organization;
  setSelectedOrganization: (org: Organization) => void;
  organizations: Organization[];
  setOrganizations: (orgs: Organization[]) => void;
};

const OrganizationContext = createContext<OrganizationContextType | undefined>(undefined);

export const OrganizationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedOrganization, setSelectedOrganization] = useState<Organization>({
    id: "",
    name: "",
    desc: "",
  });
  const [organizations, setOrganizations] = useState<any>([]);

  return (
    <OrganizationContext.Provider value={{ selectedOrganization, setSelectedOrganization, organizations, setOrganizations }}>
      {children}
    </OrganizationContext.Provider>
  );
};

export const useOrganization = (): OrganizationContextType => {
  const context = useContext(OrganizationContext);
  if (!context) {
    throw new Error("useOrganization must be used within an OrganizationProvider");
  }
  return context;
};
